import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { IDENTITY_SUFFIX } from '../../../../constants';

const useStyles = makeStyles(() =>
  createStyles({
    messageInfoContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '1.425em 0 0.083em',
      fontSize: '12px',
      color: '#606B85',
    },
  })
);

interface MessageInfoProps {
  author: string;
  dateCreated: string;
  isLocalParticipant: boolean;
}

export default function MessageInfo({ author, dateCreated, isLocalParticipant }: MessageInfoProps) {
  const classes = useStyles();
  const identityReg = new RegExp(`${IDENTITY_SUFFIX}.*`);
  console.log('author, dateCreated, isLocalParticipant', author, dateCreated, isLocalParticipant);
  const replacedAuthor = author.replace(identityReg, '');
  return (
    <div className={classes.messageInfoContainer}>
      <div>{isLocalParticipant ? `${replacedAuthor} (You)` : replacedAuthor}</div>
      <div>{dateCreated}</div>
    </div>
  );
}
